import {
  Activity,
  Apple,
  Bed,
  Bone,
  Brain,
  Coffee,
  Droplet,
  Dumbbell,
  Flame,
  GlassWater,
  Heart,
  HelpCircle,
  Leaf,
  Milk,
  Moon,
  Pill,
  Search,
  Snowflake,
  Stethoscope,
  Thermometer,
  Waves,
  Zap,
  Ban,
  AlertTriangle,
  Check,
  X,
  Sparkles,
  PartyPopper,
  BookOpen,
  Wrench,
  Package,
  type LucideIcon,
} from "lucide-react";

const EMOJI_MAP: Record<string, LucideIcon> = {
  "🔥": Flame,
  "🧠": Brain,
  "😴": Moon,
  "💤": Moon,
  "🌙": Moon,
  "❤️": Heart,
  "🫀": Heart,
  "⚡": Zap,
  "💪": Dumbbell,
  "🦴": Bone,
  "🩺": Stethoscope,
  "🤔": HelpCircle,
  "🌡️": Thermometer,
  "💊": Pill,
  "🧴": Droplet,
  "💧": Droplet,
  "🌿": Leaf,
  "🍎": Apple,
  "🥗": Apple,
  "🧘": Activity,
  "🚰": GlassWater,
  "🍷": GlassWater,
  "🚬": Ban,
  "🌶️": Flame,
  "🛏️": Bed,
  "☕️": Coffee,
  "🍵": Coffee,
  "🥛": Milk,
  "🧊": Snowflake,
  "🌊": Waves,
  "🥵": Flame,
  "🤯": Brain,
  "😓": Droplet,
  "🚫": Ban,
  "⚠️": AlertTriangle,
  "✅": Check,
  "❌": X,
  "🎉": PartyPopper,
  "🌟": Sparkles,
  "✨": Sparkles,
  "🔍": Search,
  "📚": BookOpen,
  "🛠️": Wrench,
  "📦": Package,
};

export function iconForEmoji(emoji: string | null | undefined): LucideIcon {
  if (!emoji) return Search;
  return EMOJI_MAP[emoji] || Search;
}

export function categoryIcon(category: string): LucideIcon {
  switch (category) {
    case "physical":
      return Dumbbell;
    case "mental_emotional":
      return Brain;
    case "urogenital":
      return Stethoscope;
    case "sleep":
      return Moon;
    case "cognitive":
      return Brain;
    case "cardiovascular":
      return Heart;
    case "metabolic":
      return Zap;
    default:
      return Search;
  }
}
